// API configuration
// In development, uses proxy from package.json (localhost:3001)
// In production, always uses relative path (Vercel rewrites handle routing to backend)

const getApiUrl = () => {
  // Always use relative path - Vercel rewrites will handle routing to backend
  // In development, proxy from package.json handles routing to localhost:3001
  // In production, Vercel rewrites handle routing to Railway backend
  return '';
};

export const API_BASE_URL = getApiUrl();

// Helper function to build full API URL
export const buildApiUrl = (path) => {
  const baseUrl = API_BASE_URL;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  if (baseUrl) {
    // Remove trailing slash from baseUrl if present
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    return `${cleanBaseUrl}/api${cleanPath}`;
  }
  
  // If no base URL, use relative path
  return `/api${cleanPath}`;
};

export default API_BASE_URL;

